/**
 * @generated SignedSource<<d83fb9fabf251f44c1a712c7e4ae8ea4>>
 * @relayHash dc139391c86cd8515359d40e11716ac3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc139391c86cd8515359d40e11716ac3

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountVerificationStatus = "IN_PROGRESS" | "REJECTED" | "VERIFIED";
export type BetterDoc = "ALLOWED" | "CONDITION_PACKAGE" | "NOT_ALLOWED" | "REQUIRED";
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type Gatekeeper = "GENERAL_PRACTITIONER" | "MEDGATE_AND_OTHERS" | "MEDGATE_ONLY" | "NOT_MEDGATE" | "NO_GATEKEEPER";
export type HealthInformationType = "ALLERGY" | "BODY_MEASUREMENT" | "CONDITION" | "FAMILY_HISTORY" | "GYNAECOLOGY" | "SOCIAL_HISTORY";
export type PreventionProgramDismissReason = "APPOINTMENT_ALREADY_BOOKED_THROUGH_MEDGATE" | "PATIENT_HAS_NO_INCREASED_RISK" | "PATIENT_IS_ALREADY_IN_PROGRAM" | "PATIENT_IS_NOT_INTERESTED" | "PATIENT_SELF_ORGANIZES";
export type PreventionProgramEngagementStatus = "BOOKED" | "DISMISSED";
export type ReferralToGeneralPractitioner = "INSURANCE_LIST" | "MPN" | "NONE";
export type ReferralToSpecialist = "INSURANCE_LIST" | "MPN" | "NONE";
export type dePatientByIdQuery$variables = {
  appointmentId?: string | null;
  patientId: string;
};
export type dePatientByIdQuery$data = {
  readonly patientById: {
    readonly __typename: "de_Patient";
    readonly account: {
      readonly accountVerification: {
        readonly emailAddress: string;
        readonly phoneNumber: string;
        readonly status: AccountVerificationStatus;
      } | null;
      readonly childProfiles: ReadonlyArray<{
        readonly patient: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PatientFragment">;
        };
      }>;
      readonly mainProfile: {
        readonly patient: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PatientFragment">;
        };
      } | null;
    } | null;
    readonly address: {
      readonly city: string;
      readonly country: {
        readonly code: string;
        readonly countryLookupTranslations: ReadonlyArray<{
          readonly countryIsoCode2: string;
          readonly countryName: string;
          readonly language: string;
        }>;
        readonly id: string;
      } | null;
      readonly countryCode: string;
      readonly houseNumberStreet: string;
      readonly postalCode: string;
    } | null;
    readonly allergiesInformation: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientAllergiesOutputFragment">;
    };
    readonly bodyMeasurements: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PatientBodyMeasurementsOutputFragment" | "PatientBodyMeasurementsOutputFragmentInline">;
      }> | null;
    } | null;
    readonly callerPhoneNumbers: ReadonlyArray<string> | null;
    readonly caveEntry: {
      readonly message: string | null;
      readonly updatedAt: string;
      readonly updatedBy: string;
    } | null;
    readonly conditionInformation: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientConditionInformationOutputFragment">;
    };
    readonly contactChannel: ContactChannel;
    readonly contactChannelUpdatedAt: string | null;
    readonly contextAppointment: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientContextAppointmentFragment">;
    } | null;
    readonly createdAt: string;
    readonly duplicateOfPatient: {
      readonly id: string;
    } | null;
    readonly emailAddress: string | null;
    readonly emailVerification: {
      readonly createdAt: string;
      readonly sentAt: string | null;
      readonly verifiedAt: string | null;
    } | null;
    readonly familyHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"FamilyHistoryFragment">;
    };
    readonly gynaecology: {
      readonly " $fragmentSpreads": FragmentRefs<"GynaecologyFragment">;
    };
    readonly hasUpcomingPlannedAppointment: boolean;
    readonly healthInformationLastVerification: ReadonlyArray<{
      readonly healthInformationType: HealthInformationType;
      readonly id: string;
      readonly patientId: string;
      readonly verifiedAt: string | null;
      readonly verifiedBy: string | null;
    }>;
    readonly healthInformationVerifications: ReadonlyArray<{
      readonly appointmentId: number;
      readonly healthInformationType: HealthInformationType;
      readonly id: string;
      readonly patientId: string;
      readonly verifiedAt: string | null;
      readonly verifiedBy: string | null;
    }>;
    readonly id: string;
    readonly insurees: ReadonlyArray<{
      readonly activeCoverages: ReadonlyArray<{
        readonly id: string;
        readonly policyNumber: string | null;
        readonly product: {
          readonly id: string;
          readonly isPrimary: boolean;
          readonly name: string;
          readonly organisation: {
            readonly id: string;
            readonly key: string;
          };
          readonly productConfiguration: {
            readonly __typename: "de_ProductConfiguration";
            readonly betterDoc: BetterDoc;
            readonly betterDocKey: string;
            readonly gatekeeper: Gatekeeper | null;
            readonly isMedgateTeleGeneralPractitioner: boolean | null;
            readonly shouldContainInsuranceCardNumber: boolean | null;
          } | null;
        };
        readonly updatedAt: string | null;
        readonly validFrom: any;
        readonly validTo: any;
      }>;
      readonly coverages: ReadonlyArray<{
        readonly id: string;
        readonly policyNumber: string | null;
        readonly product: {
          readonly id: string;
          readonly isPrimary: boolean;
          readonly name: string;
          readonly organisation: {
            readonly id: string;
            readonly key: string;
          };
          readonly productConfiguration: {
            readonly __typename: "de_ProductConfiguration";
            readonly betterDoc: BetterDoc;
            readonly betterDocKey: string;
            readonly gatekeeper: Gatekeeper | null;
            readonly isMedgateTeleGeneralPractitioner: boolean | null;
            readonly shouldContainInsuranceCardNumber: boolean | null;
          } | null;
        };
        readonly updatedAt: string | null;
        readonly validFrom: any;
        readonly validTo: any;
      }>;
      readonly id: string;
      readonly insureeNumber: string | null;
      readonly organisation: {
        readonly id: string;
        readonly name: string;
      };
    }>;
    readonly medgateServiceInfo: {
      readonly betterDoc: BetterDoc;
      readonly externalAssistanceServiceInfo: {
        readonly name: string;
      } | null;
      readonly genericsObligation: boolean;
      readonly hasBetterDocConditionPackage: boolean;
      readonly hasInsuranceListReferralToGeneralPractitioner: boolean;
      readonly hasInsuranceListReferralToSpecialist: boolean;
      readonly isEligibleToPartnerPortal: boolean;
      readonly isMedgateTeleGeneralPractitioner: boolean;
      readonly isMedicalChatEnabled: boolean;
      readonly referralToGeneralPractitioner: ReferralToGeneralPractitioner;
      readonly referralToSpecialist: ReferralToSpecialist;
    };
    readonly medications: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly endDate: any | null;
          readonly id: string;
          readonly pharmaceuticalCentralNumber: string | null;
          readonly startDate: any | null;
          readonly " $fragmentSpreads": FragmentRefs<"deMedicationFragment" | "deMedicationFragmentInline">;
        };
      }> | null;
    } | null;
    readonly patientId: string;
    readonly phoneNumber: string | null;
    readonly preventionPrograms: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly dismissReason: PreventionProgramDismissReason | null;
          readonly id: string;
          readonly key: string;
          readonly lastUpdated: string | null;
          readonly localizedInstruction: {
            readonly de: string;
            readonly en: string;
          };
          readonly name: {
            readonly de: string;
            readonly en: string;
          };
          readonly status: PreventionProgramEngagementStatus | null;
        };
      }> | null;
    } | null;
    readonly socialHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"SocialHistoryFragment">;
    };
    readonly teleGpOnboardingPerformed: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"PatientFragment" | "PatientFragmentInline" | "submitBtnAgendaTeleconsultationPatientFragment">;
  } | null;
};
export type dePatientByIdQuery = {
  response: dePatientByIdQuery$data;
  variables: dePatientByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appointmentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patientId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PatientFragment"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birthDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "houseNumberStreet",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryLanguage",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secondaryLanguages",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "years",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "months",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weeks",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "days",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v24 = [
  (v7/*:: as any*/)
],
v25 = [
  (v7/*:: as any*/),
  (v23/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockedBy",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockRequestedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockRequestedBy",
    "storageKey": null
  },
  {
    "alias": "inContextOfAppointment",
    "args": null,
    "concreteType": "Appointment",
    "kind": "LinkedField",
    "name": "appointment",
    "plural": false,
    "selections": (v24/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requestInContextOfAppointmentId",
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEligibleForPreventionProgram",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "betterDoc",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMedgateTeleGeneralPractitioner",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "MedgateServiceInfo",
  "kind": "LinkedField",
  "name": "medgateServiceInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalAssistanceServiceInfo",
      "kind": "LinkedField",
      "name": "externalAssistanceServiceInfo",
      "plural": false,
      "selections": [
        (v27/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "genericsObligation",
      "storageKey": null
    },
    (v28/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBetterDocConditionPackage",
      "storageKey": null
    },
    (v29/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMedicalChatEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToGeneralPractitioner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToSpecialist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInsuranceListReferralToGeneralPractitioner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInsuranceListReferralToSpecialist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEligibleToPartnerPortal",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callerPhoneNumbers",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactChannel",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactChannelUpdatedAt",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedAt",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "de_EmailVerification",
  "kind": "LinkedField",
  "name": "emailVerification",
  "plural": false,
  "selections": [
    (v35/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentAt",
      "storageKey": null
    },
    (v34/*:: as any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "en",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "de",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v39/*:: as any*/),
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PreventionProgramsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v37/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PatientPreventionProgramOutput",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v38/*:: as any*/),
          (v41/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LocalizedInstruction",
            "kind": "LinkedField",
            "name": "localizedInstruction",
            "plural": false,
            "selections": [
              (v40/*:: as any*/),
              (v39/*:: as any*/)
            ],
            "storageKey": null
          },
          (v42/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dismissReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUpdated",
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v43/*:: as any*/)
],
v45 = {
  "alias": "code",
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v50 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appointmentId"
  }
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthInformationType",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedBy",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "appointmentId",
      "variableName": "appointmentId"
    }
  ],
  "concreteType": "HealthInformationVerification",
  "kind": "LinkedField",
  "name": "healthInformationVerifications",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    (v51/*:: as any*/),
    (v7/*:: as any*/),
    (v23/*:: as any*/),
    (v35/*:: as any*/),
    (v52/*:: as any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "HealthInformationLastVerification",
  "kind": "LinkedField",
  "name": "healthInformationLastVerification",
  "plural": true,
  "selections": [
    (v51/*:: as any*/),
    (v7/*:: as any*/),
    (v23/*:: as any*/),
    (v35/*:: as any*/),
    (v52/*:: as any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "CaveEntry",
  "kind": "LinkedField",
  "name": "caveEntry",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    (v55/*:: as any*/),
    (v56/*:: as any*/)
  ],
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insureeNumber",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "de_Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    (v27/*:: as any*/)
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "validFrom",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "validTo",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "policyNumber",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrimary",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "de_Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    (v38/*:: as any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "betterDocKey",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gatekeeper",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shouldContainInsuranceCardNumber",
  "storageKey": null
},
v68 = [
  (v7/*:: as any*/),
  (v60/*:: as any*/),
  (v61/*:: as any*/),
  (v55/*:: as any*/),
  (v62/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "de_Product",
    "kind": "LinkedField",
    "name": "product",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      (v27/*:: as any*/),
      (v63/*:: as any*/),
      (v64/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "de_ProductConfiguration",
        "kind": "LinkedField",
        "name": "productConfiguration",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v65/*:: as any*/),
          (v66/*:: as any*/),
          (v67/*:: as any*/),
          (v28/*:: as any*/),
          (v29/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyMassIndex",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pharmaceuticalCentralNumber",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refuseSubstitutes",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfPackages",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eveningDosage",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalNotes",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrescriptionRequired",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "morningDosage",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nightDosage",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noonDosage",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usageInstructions",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "composition",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPermanentPrescription",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountVerification",
  "kind": "LinkedField",
  "name": "accountVerification",
  "plural": false,
  "selections": [
    (v42/*:: as any*/),
    (v10/*:: as any*/),
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v91 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "de_Patient",
    "kind": "LinkedField",
    "name": "patient",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "storageKey": null
  }
],
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "de_Patient",
  "kind": "LinkedField",
  "name": "duplicateOfPatient",
  "plural": false,
  "selections": (v24/*:: as any*/),
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUpcomingPlannedAppointment",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teleGpOnboardingPerformed",
  "storageKey": null
},
v95 = [
  (v13/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CountryLookup",
    "kind": "LinkedField",
    "name": "country",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      (v45/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "countryLookupTranslations",
        "plural": true,
        "selections": [
          (v46/*:: as any*/),
          (v47/*:: as any*/),
          (v48/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v15/*:: as any*/),
  (v14/*:: as any*/),
  (v49/*:: as any*/)
],
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": (v95/*:: as any*/),
  "storageKey": null
},
v97 = [
  (v7/*:: as any*/),
  (v60/*:: as any*/),
  (v61/*:: as any*/),
  (v55/*:: as any*/),
  (v62/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "de_Product",
    "kind": "LinkedField",
    "name": "product",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      (v27/*:: as any*/),
      (v63/*:: as any*/),
      (v64/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "de_ProductConfiguration",
        "kind": "LinkedField",
        "name": "productConfiguration",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v65/*:: as any*/),
          (v66/*:: as any*/),
          (v67/*:: as any*/),
          (v28/*:: as any*/),
          (v29/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "icdDiagnosis",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "Age",
  "kind": "LinkedField",
  "name": "age",
  "plural": false,
  "selections": [
    (v19/*:: as any*/),
    (v20/*:: as any*/),
    (v21/*:: as any*/),
    (v22/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMajor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientFileLock",
  "kind": "LinkedField",
  "name": "patientFileLock",
  "plural": false,
  "selections": (v25/*:: as any*/),
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isContactChannelVerified",
  "storageKey": null
},
v103 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "de_Patient",
    "kind": "LinkedField",
    "name": "patient",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v3/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v23/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v96/*:: as any*/),
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v100/*:: as any*/),
          (v101/*:: as any*/),
          (v26/*:: as any*/),
          (v102/*:: as any*/),
          (v32/*:: as any*/)
        ],
        "type": "Patient",
        "abstractKey": "__isPatient"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "dePatientByIdQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v2/*:: as any*/),
        "concreteType": "de_Patient",
        "kind": "LinkedField",
        "name": "de_patientById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PatientFragmentInline",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      (v15/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*:: as any*/),
                  (v17/*:: as any*/),
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Age",
                    "kind": "LinkedField",
                    "name": "age",
                    "plural": false,
                    "selections": [
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      (v22/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PatientFileLock",
                    "kind": "LinkedField",
                    "name": "patientFileLock",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PatientFileLockFragment"
                      },
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "PatientFileLockFragmentInline",
                        "selections": (v25/*:: as any*/),
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*:: as any*/)
                ],
                "type": "Patient",
                "abstractKey": "__isPatient"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "submitBtnAgendaTeleconsultationPatientFragment"
          },
          (v7/*:: as any*/),
          (v23/*:: as any*/),
          (v30/*:: as any*/),
          (v10/*:: as any*/),
          (v18/*:: as any*/),
          (v31/*:: as any*/),
          (v32/*:: as any*/),
          (v33/*:: as any*/),
          (v34/*:: as any*/),
          (v36/*:: as any*/),
          {
            "alias": "preventionPrograms",
            "args": null,
            "concreteType": "PreventionProgramsConnection",
            "kind": "LinkedField",
            "name": "__PatientPreventionProgramsConnection_preventionPrograms_connection",
            "plural": false,
            "selections": (v44/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v13/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/),
                  (v45/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CountryLookupTranslation",
                    "kind": "LinkedField",
                    "name": "countryLookupTranslations",
                    "plural": true,
                    "selections": [
                      (v46/*:: as any*/),
                      (v47/*:: as any*/),
                      (v48/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*:: as any*/),
              (v14/*:: as any*/),
              (v49/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "contextAppointment",
            "args": (v50/*:: as any*/),
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientContextAppointmentFragment"
              }
            ],
            "storageKey": null
          },
          (v53/*:: as any*/),
          (v54/*:: as any*/),
          (v57/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "de_Insuree",
            "kind": "LinkedField",
            "name": "insurees",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v58/*:: as any*/),
              (v59/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Coverage",
                "kind": "LinkedField",
                "name": "activeCoverages",
                "plural": true,
                "selections": (v68/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Coverage",
                "kind": "LinkedField",
                "name": "coverages",
                "plural": true,
                "selections": (v68/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientConditionInformationOutput",
            "kind": "LinkedField",
            "name": "conditionInformation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientConditionInformationOutputFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Gynaecology",
            "kind": "LinkedField",
            "name": "gynaecology",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GynaecologyFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientAllergiesOutput",
            "kind": "LinkedField",
            "name": "allergiesInformation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientAllergiesOutputFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FamilyHistoryFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SocialHistoryFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "bodyMeasurements",
            "args": null,
            "concreteType": "BodyMeasurementsConnection",
            "kind": "LinkedField",
            "name": "__PatientByIdConnection_bodyMeasurements_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BodyMeasurementsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PatientBodyMeasurementsOutputFragment"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "PatientBodyMeasurementsOutputFragmentInline",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BodyMeasurement",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*:: as any*/),
                          (v69/*:: as any*/),
                          (v70/*:: as any*/),
                          (v71/*:: as any*/),
                          (v72/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  (v37/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BodyMeasurement",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v43/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "medications",
            "args": null,
            "concreteType": "De_medicationsConnection",
            "kind": "LinkedField",
            "name": "__DePatientByIdConnection_de_medications_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "De_medicationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "de_Medication",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*:: as any*/),
                      (v73/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "deMedicationFragment"
                      },
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "deMedicationFragmentInline",
                        "selections": [
                          (v3/*:: as any*/),
                          (v7/*:: as any*/),
                          (v76/*:: as any*/),
                          (v77/*:: as any*/),
                          (v74/*:: as any*/),
                          (v78/*:: as any*/),
                          (v79/*:: as any*/),
                          (v80/*:: as any*/),
                          (v81/*:: as any*/),
                          (v27/*:: as any*/),
                          (v82/*:: as any*/),
                          (v83/*:: as any*/),
                          (v23/*:: as any*/),
                          (v75/*:: as any*/),
                          (v73/*:: as any*/),
                          (v84/*:: as any*/),
                          (v85/*:: as any*/),
                          (v86/*:: as any*/),
                          (v87/*:: as any*/),
                          (v55/*:: as any*/),
                          (v56/*:: as any*/),
                          (v34/*:: as any*/),
                          (v88/*:: as any*/),
                          (v89/*:: as any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      },
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v37/*:: as any*/)
                ],
                "storageKey": null
              },
              (v43/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v90/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Profile",
                "kind": "LinkedField",
                "name": "mainProfile",
                "plural": false,
                "selections": (v91/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Profile",
                "kind": "LinkedField",
                "name": "childProfiles",
                "plural": true,
                "selections": (v91/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v92/*:: as any*/),
          (v93/*:: as any*/),
          (v94/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "dePatientByIdQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v2/*:: as any*/),
        "concreteType": "de_Patient",
        "kind": "LinkedField",
        "name": "de_patientById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v7/*:: as any*/),
          (v23/*:: as any*/),
          (v30/*:: as any*/),
          (v10/*:: as any*/),
          (v18/*:: as any*/),
          (v31/*:: as any*/),
          (v32/*:: as any*/),
          (v33/*:: as any*/),
          (v34/*:: as any*/),
          (v36/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PreventionProgramsConnection",
            "kind": "LinkedField",
            "name": "preventionPrograms",
            "plural": false,
            "selections": (v44/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "PatientPreventionProgramsConnection_preventionPrograms",
            "kind": "LinkedHandle",
            "name": "preventionPrograms"
          },
          (v96/*:: as any*/),
          {
            "alias": "contextAppointment",
            "args": (v50/*:: as any*/),
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v42/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCompleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "service",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appointmentType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientPhoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startingSoonNotificationSent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AppointmentChatDetails",
                "kind": "LinkedField",
                "name": "chatDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "chatThreadId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "channel",
                "storageKey": null
              },
              (v48/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medgateConnectChannel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partnerUserEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "asyncRequestStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RequestedMedication",
                "kind": "LinkedField",
                "name": "requestedMedications",
                "plural": true,
                "selections": [
                  (v27/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mainSubstance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "packageSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pharmaCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "productUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAttribute",
                "kind": "LinkedField",
                "name": "billingAttribute",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isNotBillable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notBillableReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "treatmentReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVisualSymptomExamination",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentGestationWeek",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organisationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateOfAccident",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accidentReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEmployer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lawType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ivgCaseReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mvgCaseReference",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FileUploadRequest",
                "kind": "LinkedField",
                "name": "fileUploadRequest",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/),
                  (v34/*:: as any*/),
                  (v88/*:: as any*/),
                  (v87/*:: as any*/),
                  (v42/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionCode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "patientAddress",
                "plural": false,
                "selections": (v95/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "relatedPreventionPrograms",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v38/*:: as any*/),
                  (v23/*:: as any*/),
                  (v7/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "preventionProgramId",
                    "storageKey": null
                  },
                  (v41/*:: as any*/),
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PreventionProgramAnalysis",
                    "kind": "LinkedField",
                    "name": "analysis",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "matchedCase",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pointOfCare",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "treatmentPlanTemplateId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v53/*:: as any*/),
          (v54/*:: as any*/),
          (v57/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "de_Insuree",
            "kind": "LinkedField",
            "name": "insurees",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v58/*:: as any*/),
              (v59/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Coverage",
                "kind": "LinkedField",
                "name": "activeCoverages",
                "plural": true,
                "selections": (v97/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Coverage",
                "kind": "LinkedField",
                "name": "coverages",
                "plural": true,
                "selections": (v97/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientConditionInformationOutput",
            "kind": "LinkedField",
            "name": "conditionInformation",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v42/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ConditionOutput",
                "kind": "LinkedField",
                "name": "conditions",
                "plural": true,
                "selections": [
                  (v98/*:: as any*/),
                  (v99/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Gynaecology",
            "kind": "LinkedField",
            "name": "gynaecology",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstPeriod",
                "storageKey": null
              },
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "menopauseSince",
                "storageKey": null
              },
              (v23/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pregnancy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pregnancyHistory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weeksOfPregnancy",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientAllergiesOutput",
            "kind": "LinkedField",
            "name": "allergiesInformation",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v42/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AllergyOutput",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  (v7/*:: as any*/),
                  (v98/*:: as any*/),
                  (v99/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoimmuneDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heartDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diabetes",
                "storageKey": null
              },
              (v98/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v98/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "drinkingHabit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "smokingHabit",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BodyMeasurementsConnection",
            "kind": "LinkedField",
            "name": "bodyMeasurements",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BodyMeasurementsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BodyMeasurement",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*:: as any*/),
                      (v69/*:: as any*/),
                      (v70/*:: as any*/),
                      (v71/*:: as any*/),
                      (v72/*:: as any*/),
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v37/*:: as any*/)
                ],
                "storageKey": null
              },
              (v43/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "PatientByIdConnection_bodyMeasurements",
            "kind": "LinkedHandle",
            "name": "bodyMeasurements"
          },
          {
            "alias": "medications",
            "args": null,
            "concreteType": "De_medicationsConnection",
            "kind": "LinkedField",
            "name": "de_medications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "De_medicationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "de_Medication",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*:: as any*/),
                      (v73/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v3/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v79/*:: as any*/),
                      (v80/*:: as any*/),
                      (v81/*:: as any*/),
                      (v27/*:: as any*/),
                      (v82/*:: as any*/),
                      (v83/*:: as any*/),
                      (v23/*:: as any*/),
                      (v84/*:: as any*/),
                      (v85/*:: as any*/),
                      (v86/*:: as any*/),
                      (v87/*:: as any*/),
                      (v55/*:: as any*/),
                      (v56/*:: as any*/),
                      (v34/*:: as any*/),
                      (v88/*:: as any*/),
                      (v89/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v37/*:: as any*/)
                ],
                "storageKey": null
              },
              (v43/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "medications",
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "DePatientByIdConnection_de_medications",
            "kind": "LinkedHandle",
            "name": "de_medications"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v90/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Profile",
                "kind": "LinkedField",
                "name": "mainProfile",
                "plural": false,
                "selections": (v103/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "de_Profile",
                "kind": "LinkedField",
                "name": "childProfiles",
                "plural": true,
                "selections": (v103/*:: as any*/),
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v92/*:: as any*/),
          (v93/*:: as any*/),
          (v94/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v100/*:: as any*/),
              (v101/*:: as any*/),
              (v26/*:: as any*/),
              (v102/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "insurees",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "activeCoverages",
                    "plural": true,
                    "selections": [
                      (v3/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "productConfiguration",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nursingRate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Patient",
            "abstractKey": "__isPatient"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "dc139391c86cd8515359d40e11716ac3",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "patientById",
            "preventionPrograms"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "patientById",
            "bodyMeasurements"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "patientById",
            "medications"
          ]
        }
      ]
    },
    "name": "dePatientByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7097408fe68b48c4b88fef0679891c4f";

export default node;
